import React, { useEffect, useRef, useState } from 'react';

import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';

const AudioControls = ({ src }) => {
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!audioRef.current) return;

    const method = isAudioPlaying ? 'play' : 'pause';

    audioRef.current[method]();
  }, [isAudioPlaying]);

  const handleToggleAudio = () => {
    setIsAudioPlaying(!isAudioPlaying);
  };

  const isAudioPlayingPrefix = isAudioPlaying ? 'Pause' : 'Play';

  return (
    <div className="flex-center-center h-with-2x-large-y-padding">
      {!src ? (
        <strong className="margin-right-1x">No audio</strong>
      ) : (
        <>
          <audio ref={audioRef} className="h-hide" controls>
            <source src={src} type="audio/mpeg" />
          </audio>
          <div className="flex-center-center space-between">
            <strong className="margin-right-1x">{isAudioPlayingPrefix} audio</strong>
            <ToggleSwitch
              name="Audio toggle"
              checkedColor="#1e0059"
              uncheckedColor="#b2b0a7"
              isChecked={isAudioPlaying}
              onChange={handleToggleAudio}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default AudioControls;
